require('./brokerWarrantsProductFileView.scss');

const PropTypes = require('prop-types');
const comlexity_icon = require('assets/icons/complexity_icon.svg');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');


// @ actions
const WarrantFileActions = require('actions/brokerGetWarrantFile.js');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');
const TabbedBox = require('components/commons/tabbedBox/tabbedBox');
const LineChartWarrantHistorical = require('components/d3Components/lineChartWarrantHistorical/lineChartWarrantHistorical');
const { EmptyState } = require('commonsComponents/emptyState');

// @ components
const { BrokerWarrantsHeader } = require('components/broker/brokerProductHeaders/brokerWarrantsHeader/brokerWarrantsHeader');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const { PROC_BROKER_WARRANTS_PG_NAME } = require('utilities/tagging');

// @ helpers
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @Contact Center
const WebappRender = require('components/conditionalRender/webappRender')

// @ constants
const { WARRANTS_DETAILS } = require('constants/flagBasedFeatures');
const { MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    BROKER_INFO_SCREEN
} = require('constants/index');

class BrokerWarrantsProductFileView extends React.Component {
    constructor(props) {
        super(props);

        this.getProductDetails = this.getProductDetails.bind(this);
        this.getHistoricalData = this.getHistoricalData.bind(this);
        this.getCatalogueDetails = this.getCatalogueDetails.bind(this);

    }

    componentDidMount() {
        this.getProductDetails();
        this.getHistoricalData();
        this.getCatalogueDetails();
        this.props.fetchOpenTraderLink();
        this.props.checkPersonalInformationData();
        scrollToTop();
    }

    getHistoricalData() {
        this.props.getHistoricalRequest(this.props.match.params.isin, this.props.match.params.iso);
    }

    getProductDetails() {
        const { getWarrantDetails, match: { params: { isin, iso } } } = this.props;
        getWarrantDetails(isin, iso, BROKER_INFO_SCREEN);
    }

    getCatalogueDetails() {
        this.props.getWarrantCatalogueDetails(this.props.match.params.isin);
    }

    renderProductFileContent = () => {
        const { productFile } = this.props;
        if (!productFile.get('error')) {
            return (
                <ContentBox customClassName="broker-warrants-product-file-body">
                    <TabbedBox
                        onlyTabs
                        onlyContent
                        id="brokerWarrantProductTabs"
                        tabs={this.renderTabs()}
                        customClassName="broker-warrants-product-file__content"
                    />
                </ContentBox>
            );
        }
        return null;
    }

    renderEvolution = (data) => {
        if (data) {
            return <LineChartWarrantHistorical width="1140" height="300" dataset={data} />
        }
        return (
            <div className="broker-warrants-product-file-view__graph-no-data">
                <EmptyState primaryText={formatText('broker-warrantsChartsEmpty')} iconType="nointernet-wealth" />
            </div>
        )
    }

    renderTabs = () => {
        const { warrantFile } = this.props;
        const warrantChartData = warrantFile.get('warrantChart');
        const underlyingChartData = warrantFile.get('underlyingChart');
        return [
            {
                label: <span onClick={() => taggingEventHandled(PROC_BROKER_WARRANTS_PG_NAME, 'tabs', 'evolution')}>{formatText('broker-warrantsQuoteTitleLabel')}</span>,
                content: (
                    <div>
                        <h2>
                            {formatText('broker-evolutionText')}
                        </h2>
                        {this.renderEvolution(warrantChartData)}
                    </div>
                )
            },
            {
                label: <span onClick={() => taggingEventHandled(PROC_BROKER_WARRANTS_PG_NAME, 'tabs', 'price')}>{formatText('broker-warrantsUndelyingQuoteTitleLabel')}</span>,
                content: (
                    <div>
                        <h2>
                            {formatText('broker-evolutionText')}
                        </h2>
                        {this.renderEvolution(underlyingChartData)}
                    </div>
                )
            }
        ];
    }

    render() {
        const { immMyInvestments, immOpenTrader, productFile, warrantFile } = this.props;
        const warrantsProductSubtitle = formatText('broker-warrantsProductFileViewSubtitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: ''
            }
        ];

        return (
            <div className="broker-warrants-product-file-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="broker" customClass="col-xs-12">
                            <BrokerTruncatedBreadcrumb
                                titleKey="broker-productFileTitle"
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={warrantsProductSubtitle}
                            >
                                <OKButton onClick={() => taggingEventHandled(PROC_BROKER_WARRANTS_PG_NAME, 'searchButtonOnProduct')} inverse={true} modifier="ghost" to={MYPROFILE_BROKER_EXPLORE_URL}>
                                    <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                                </OKButton>
                                <WebappRender>
                                    <OKButton onClick={() => taggingEventHandled(PROC_BROKER_WARRANTS_PG_NAME, 'openTraderButton')} inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                        <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                    </OKButton>
                                </WebappRender>
                            </BrokerTruncatedBreadcrumb>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="broker-warrants-product-file-view__warrants-risk-indicator">
                            <FormattedText value="fundsCard-alertComplexity_title" /><br />
                            <img src={comlexity_icon} alt="complexity icon" /> <FormattedText value="fundsCard-alertComplexity_content" />
                        </div>
                        <div className="row grid-view--content-position-negative broker-warrants-product-file-view--content-position-warrants">
                            <div className="col-xs-12">
                                <BrokerWarrantsHeader
                                    productFile={productFile}
                                    warrantFile={warrantFile}
                                    immMyInvestments={immMyInvestments}
                                    handleUpdate={this.getProductDetails}
                                    isin={this.props.match.params.isin}
                                    iso={this.props.match.params.iso}
                                    showClientWarningModal={this.props.showClientWarningModal}
                                    immbrokerClientWarningModal={this.props.immbrokerClientWarningModal}
                                    fireTaggingBuyButton={(isin) => taggingEventHandled(PROC_BROKER_WARRANTS_PG_NAME, 'buttonBuy', isin)}
                                />
                                <FeatureTogglingRender notAllowedProductKey={WARRANTS_DETAILS} >
                                    {this.renderProductFileContent()}
                                </FeatureTogglingRender>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerWarrantsProductFileView.propTypes = {
    immMyInvestments: PropTypes.object.isRequired,
    match: PropTypes.object,
    getWarrantDetails: PropTypes.func,
    getWarrantsProduct: PropTypes.func,
    getHistoricalRequest: PropTypes.func,
    getWarrantCatalogueDetails: PropTypes.func,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    immOpenTrader: PropTypes.object.isRequired,
    productFile: PropTypes.object,
    warrantFile: PropTypes.object,
    immbrokerClientWarningModal: PropTypes.object,
    showClientWarningModal: PropTypes.func,
    immProfile: PropTypes.object,
    checkPersonalInformationData: PropTypes.func,
};

module.exports.constructor = BrokerWarrantsProductFileView;
module.exports.BrokerWarrantsProductFileView = withRouter(connect(
    state => ({
        immOpenTrader: state.brokerOpenTrader,
        productFile: state.brokerProductFile,
        warrantFile: state.brokerWarrantsFile,
        immMyInvestments: state.brokerMyInvestments,
        immbrokerClientWarningModal: state.brokerClientWarningModal,
        immProfile: state.profile
    }),
    {
        getWarrantDetails: WarrantFileActions.getWarrantFile,
        getHistoricalRequest: WarrantFileActions.getHistoricalRequest,
        getWarrantCatalogueDetails: WarrantFileActions.getWarrantCatalogueDetails,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal,
        checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData,
    }
)(BrokerWarrantsProductFileView));
